module.exports = __webpack_public_path__ + "img/ReviewDetails_3.f1f43f05.png";